// extracted by mini-css-extract-plugin
export default {"container":"_1c49cf38","heading":"_7ab90b97"};